module.exports = __webpack_public_path__ + "exo-latin-600.ca209404a4885958c612.svg";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-600.svg
// module id = ../../../../typeface-exo/files/exo-latin-600.svg
// module chunks = styles